<template>
  <div class="payment-input">
    <b-form-input
      v-if="CombineShipments == 0"
      autocomplete="off"
      ref="AmountInput"
      @focus.native="$event.target.select()"
      id="input-large"
      size="lg"
      type="number"
      :value="CurrentAmount"
    ></b-form-input>
    <b-list-group>
      <b-list-group-item v-if="ChangeAmount > 0" variant="secondary"
        >Devolver {{ ChangeAmount }}</b-list-group-item
      >
      <b-list-group-item
        v-if="this.$store.state.curDocType == 1"
        variant="primary"
      >
        <b-form-checkbox
          @change="clearPaym()"
          id="IsAnticipo_cb"
          v-model="IsAnticipo"
          >Anticipo</b-form-checkbox
        >
      </b-list-group-item>
      <b-list-group-item
        v-if="this.$store.state.orderPrePayments.length > 0"
        @click="PostPrintPrePayment()"
        variant="secondary"
        button
        >IMPRIMIR ANTICIPO</b-list-group-item
      >
      <div v-if="CombineShipments == 0">
        <!-- FORMAS DE PAGO -->
        <b-list-group-item
          button
          @click="CheckVoucher(option)"
          variant="success"
          v-for="option in options"
          :key="option.paymenttype"
          >{{ option.paymentdesc }}</b-list-group-item
        >
      </div>
      <b-list-group-item variant="secondary">{{
        customer.id + " - " + customer.name
      }}</b-list-group-item>
      <b-list-group-item
        v-if="IsAnticipo == false"
        button
        @click="CheckAmountBeforePosting()"
        variant="primary"
        >REGISTRAR</b-list-group-item
      >
      <b-list-group-item
        v-if="IsAnticipo == true"
        button
        @click="PostPrintPrePayment()"
        variant="primary"
        >REGISTRAR ANTICIPO</b-list-group-item
      >
      <b-list-group-item
        v-if="printdoc"
        button
        @click="GoToPos()"
        variant="danger"
        >{{ printdoc }}</b-list-group-item
      >
      <b-list-group-item
        v-if="this.$store.state.curDocType == 4"
        @click="PrintInvoice()"
        variant="success"
        button
        >IMPRIMIR</b-list-group-item
      >

      <!-- <b-list-group-item button @click="Finalize()" variant="primary">FINALIZAR</b-list-group-item> -->
    </b-list-group>

    <!-- Modal Component para solo permitir imprimir tras Registro Correcto. -->
    <b-modal
      @hide="ModalClose"
      no-close-on-backdrop
      hide-footer
      ref="ModalRef"
      id="modal1"
      :title="this.printdoc"
    >
      <b-list-group>
        <Signature />
        <b-list-group-item v-if="this.$store.state.vale != 1" button @click="PrintDoc()" variant="primary">{{
          PrintButtonText
        }}</b-list-group-item>

        <b-list-group-item
          v-if="ticketPrinter != '' && this.$store.state.vale != 1"
          button
          @click="PrintTicket(0)"
          variant="primary"
          >Imprimir Ticket</b-list-group-item
        >
        <b-list-group-item
          v-if="ticketPrinter != '' && this.$store.state.vale != 1"
          button
          @click="PrintTicket(1)"
          variant="primary"
          >Imprimir Ticket Regalo</b-list-group-item
        >

        <b-list-group-item
          v-if="ticketPrinter != '' && docVouchers.length"
          button
          @click="PrintDocVouchers(0)"
          variant="primary"
          >Imprimir vales {{ docVouchers }}</b-list-group-item
        >
        <b-btn class="mt-3" variant="outline-danger" block @click="ModalClose"
          >Finalizar</b-btn
        >
      </b-list-group>
    </b-modal>

    <!-- Modal Component para solo permitir imprimir tras Registro Correcto. -->
    <b-modal
      @hide="ModalClose"
      hide-footer
      ref="ModalRefPayments"
      id="modal2"
      title="Registro de cobro"
    >
      <b-list-group>
        <p class="my-4">{{ ModalMsg }}</p>
        <b-btn class="mt-3" variant="outline-danger" block @click="ModalClose"
          >Finalizar</b-btn
        >
      </b-list-group>
    </b-modal>
    <!-- Modal Component para solicitar un número de vale. -->
    <b-modal
      no-close-on-backdrop
      hide-footer
      ref="VoucherModalRef"
      id="vouchermodal"
      title="Nº de Vale"
    >
      <b-list-group>
        <Signature />
        <b-form-input
          id="voucherNo"
          type="text"
          v-model="voucherNo"
          required
          placeholder="Nº de vale..."
        ></b-form-input>
        <b-btn
          class="mt-3"
          variant="outline-success"
          @click="GetVoucherBalance()"
          >Buscar vale</b-btn
        >
        <b-list-group>
          <p class="my-4">
            SALDO: {{ parseFloat(voucherAmount).toFixed(2) + " €" }}
          </p>
        </b-list-group>
        <b-btn
          class="mt-3"
          variant="outline-success"
          @click="VoucherModalAccept()"
          >Procesar vale</b-btn
        >
        <b-btn
          class="mt-3"
          variant="outline-danger"
          @click="VoucherModalCancel()"
          >Cancelar</b-btn
        >
      </b-list-group>
    </b-modal>

    <!-- Modal Component para advertencia de formas de pago -->
    <b-modal
      @hide="WarningCancel"
      hide-footer
      ref="ModalRefWarning"
      id="modalWarning"
      title="Advertencia"
    >
      <b-list-group>
        <p class="my-4">{{ WarningMsg }}</p>
        <b-btn
          class="mt-3"
          variant="outline-danger"
          block
          @click="WarningCancel"
          >Cancelar</b-btn
        >
        <b-btn class="mt-3" variant="outline-success" block @click="Post"
          >Continuar</b-btn
        >
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import mixin from "@/components/mixin.js";
import Signature from "@/components/Signature.vue";
import ticketPrint from "@/components/ticketPrint.js";

export default {
  mixins: [mixin, ticketPrint],
  name: "PaymentInput",
  data() {
    return {
      options: [],
      CurrentAmount: 0,
      ChangeAmount: 0,
      IsAnticipo: false,
      status: 1, //será 0 si el pedido se registra correctamente
      ModalMsg: "",
      processing: false,
      ticketPrinter: localStorage.getItem("ticketPrinter"),
      voucherNo: "",
      voucherAmount: "",
      selectedPaymOption: [],
      WarningMsg: "",
      docVouchers: [],
    };
  },
  components: {
    Signature,
  },
  computed: {
    printdoc() {
      return this.$store.state.printdoc;
    },
    customer() {
      return this.$store.state.customer;
    },
    CombineShipments() {
      return this.$store.state.orderproperties.CombineShipments;
    },
    IsPrintable() {
      return this.$store.state.isPrintable;
    },
    PrintButtonText() {
      return this.$store.state.printButtonText;
    },
  },
  created: function () {
    this.axios
      .post(
        this.ApiBaseUrl + "possetup/pospaymentmethods",
        JSON.stringify(localStorage.getItem("posId")),
        { headers: { "Content-Type": "application/json" } }
      )
      .then((response) => {
        this.options = response.data;
      });
    this.CurrentAmount = parseFloat(
      this.$store.getters.OrderTotalIncVAT - this.$store.getters.OrderTotalPaym
    ).toFixed(2);
  },
  mounted: function () {
    this.$refs.AmountInput.focus();
    if (this.$store.state.curDocType == 9) {
      this.$refs.ModalRef.show();
    }
  },
  methods: {
    GetVoucherBalance() {
      this.axios
        .post(
          this.ApiBaseUrl + "Sales/VoucherBalance",
          JSON.stringify(this.voucherNo),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          this.voucherAmount = response.data[0];
        });
    },
    CheckVoucher(selected) {
      let option = { ...selected };
      if (option.voucherNos && 
          (this.$store.state.curDocType == 1 || 
            (this.$store.state.curDocType == 4 && this.$store.state.paymentDocType == 2) //Cobro de factura
          )
        ) {
        this.selectedPaymOption = selected;
        this.$refs.VoucherModalRef.show();
      } else {
        this.InputAmount(selected);
      }
    },
    VoucherModalAccept(hasVoucher) {
      if (this.voucherAmount > this.CurrentAmount) {
        this.$refs.AmountInput.$refs.input.value = this.CurrentAmount;
      } else {
        this.$refs.AmountInput.$refs.input.value = this.voucherAmount;
      }

      this.CurrentAmount;
      this.InputAmount(this.selectedPaymOption);
      this.$refs.VoucherModalRef.hide();
    },
    VoucherModalCancel(hasVoucher) {
      console.log("Cancelado vale");
      this.voucherNo = "";
      this.selectedPaymOption = [];
      this.$refs.VoucherModalRef.hide();
    },
    GetDocumentVouchers() {
      ///api/Sales/DocVouchers
      var voucherDocType = 0;
      var voucherDocNo = "";
      if (this.$store.state.vale == 1) {
        voucherDocType = "6";
        voucherDocNo = this.$store.state.printdoc;
      } else {
        voucherDocType = this.$store.state.curDocType;
        voucherDocNo = this.$store.state.curOrder;
      }
      var doc = {
        doctype: voucherDocType,
        docno: voucherDocNo,
      };
      
      this.axios
        .post(this.ApiBaseUrl + "Sales/DocVouchers", JSON.stringify(doc), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          //window.open(this.PrintDocsFolder + response.data.return_value);
          this.docVouchers = response.data;
          console.log(this.docVouchers);
        });
    },
    PrintDocVouchers(regalo) {
      this.docVouchers.forEach((element) => {
        console.log(element);
        let strprintdoc = "@@" + regalo + element;

        var ticketPrintReq = {
          printdoc: strprintdoc,
          ticketPrinter: localStorage.getItem("ticketPrinter"),
          ticketControllerURL: window.location.origin + this.ApiBaseUrl + "Tickets/GetPrintVoucherCmd"          
        };

        console.log(ticketPrintReq);
        this.OpenSocket(JSON.stringify(ticketPrintReq));
        
      });
    },
    InputAmount(selected) {
      let option = { ...selected };
      option.voucherNo = this.voucherNo;
      this.voucherNo = "";

      if (parseFloat(this.$refs.AmountInput.$refs.input.value) != 0) {
        let InputAmount = parseFloat(this.$refs.AmountInput.$refs.input.value);

        if (
          (InputAmount <= this.CurrentAmount || option.isCash == 1) &&
          this.CurrentAmount > 0
        ) {
          if (InputAmount > this.CurrentAmount)
            option.amount = parseFloat(this.CurrentAmount);
          else
            option.amount = parseFloat(
              this.$refs.AmountInput.$refs.input.value
            ); //Importe del input

          switch (this.$store.state.curDocType) {
            case 4:
              option.movtype = 6; //Cobro
              option.doctype = this.$store.state.paymentDocType == 2 ? 2 : 3;
              break;
            case 5:
              option.movtype = 4; //Abono
              option.doctype = 3;
              break;
            default:
              option.movtype = 4; //Venta
              if (this.$store.state.vale == 1) {
                option.doctype = 6;
              } else {
                option.doctype = 1;
              }

              break;
          }

          option.docno = this.$store.state.curOrder;
          let pdate = new Date();
          option.paymdate = new Date(
            pdate.getTime() - pdate.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0];
          option.posuserid = this.$store.state.UserCardId.return_value;
          option.anticipo = this.IsAnticipo;
          option.new = true;
          this.$store.commit("addPaymMethod", option);
          let NewAmount =
            this.CurrentAmount -
            parseFloat(this.$refs.AmountInput.$refs.input.value);
          this.CurrentAmount = parseFloat(NewAmount).toFixed(2); //Importe nuevo
          if (this.CurrentAmount < 0) {
            this.ChangeAmount = -this.CurrentAmount;
            this.CurrentAmount = 0;
          }
        } else {
          let buf = this.CurrentAmount;
          this.CurrentAmount = 0;
          this.$nextTick(() => {
            this.CurrentAmount = parseFloat(buf).toFixed(2);
          });
        }
        this.$nextTick(() => {
          this.$refs.AmountInput.focus();
        });
      }
    },
    CheckAmountBeforePosting() {
      if (this.$refs.AmountInput.$refs.input.value != 0) {
        this.WarningMsg =
          "No se ha introducido forma de pago para el total del importe. ¿Desea continuar con el registro?";
        this.$refs.ModalRefWarning.show();
      } else {
        this.$refs.ModalRefWarning.hide();
        this.Post();
      }
    },
    WarningCancel() {
      this.$refs.ModalRefWarning.hide();
    },
    Post() {
      this.$refs.ModalRefWarning.hide();
      if (
        this.$store.state.orderproperties.CombineShipments == 1 &&
        !this.$store.state.isPrintable
      ) {
        this.$store.commit("setPrintButtonText", "Imprimir Sin Firma");
      }
      if (this.processing === true) {
        return;
      }
      this.processing = true;

      var req = {
        docno: this.$store.state.curOrder,
        //paymmovs : this.$store.state.paymMethods,
        paymmovs: this.$store.getters.NewPaymMovs,
        OrderTotalPaym: this.$store.getters.OrderTotalPaym,
      };
      switch (this.$store.state.curDocType) {
        case 5:
          this.PostCrMemo(req)
          break;
        case 4:
          this.PostInvoicePayment(req)
          break;
        default:
          //this.PostSale(req)
          if (this.$store.state.vale == 1)
            this.PostSale(req)
          else
            this.PrePostSale(req)
          break;
      }
    },
    PostInvoicePayment(req) {
      this.axios
        .post(
          this.ApiBaseUrl + "PosFunctions/InvoicePaymentPost",
          JSON.stringify(req),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          this.ModalMsg = response.data;
          this.$store.commit("setprintdoc", response.data.return_value);
          this.$refs.ModalRefPayments.show();
          this.processing = false;
        });
    },
    PrePostSale(req){
      var preReq = {  type: this.$store.state.curDocType,
                      no : req.docno,
                      linesCount : this.$store.state.items.length
                    }
      
      this.axios
        .post(this.ApiBaseUrl + "PosFunctions/checkSalesOrderLineCount", JSON.stringify(preReq), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          if ((response.data.return_value === true) || (response.data.return_value === 'true') || (response.data.return_value === '1') || (response.data.return_value === 1)){
            this.PostSale(req);
          } else {
            alert('Inconsistencia entre el nº de líneas en NAV y el nº de líneas en memoria. Consulte con un administrador, el pedido no se ha registrado.');
          }
        });
    },
    PostSale(req) {
      this.axios
        .post(this.ApiBaseUrl + "PosFunctions/SalesPost", JSON.stringify(req), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          this.$store.commit("setprintdoc", response.data.return_value);
          localStorage.setItem("printdoc", this.printdoc);
          this.status = response.data.status;
          if (this.status == 0) this.$refs.ModalRef.show();
          this.GetDocumentVouchers();
          this.processing = false;
        });
    },
    PostCrMemo(req) {
      this.axios
        .post(
          this.ApiBaseUrl + "PosFunctions/SalesCrMemoPost",
          JSON.stringify(req),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          this.$store.commit("setprintdoc", response.data.return_value);
          this.status = response.data.status;
          if (this.status == 0) this.$refs.ModalRef.show();
          this.GetDocumentVouchers();
          this.processing = false;
        });
    },
    PrintDoc() {
      if (
        this.$store.getters.IsPrintable ||
        this.$store.state.orderproperties.CombineShipments != 1
      ) {
        window.open(this.PrintDocsFolder + this.printdoc + ".pdf");
      } else {
        this.GenPDFSigned();
      }
    },
    PrintTicket(regalo) {
      let strprintdoc = "";

      if (this.$store.state.curDocType == 9) {
        //reimprimir ticket
        if (this.$store.state.paymentDocType == 2)
          strprintdoc = "@@1" + "@@" + regalo + this.printdoc;
        //reimprimir factura
        else strprintdoc = "@@5" + "@@" + regalo + this.printdoc; //reimprimir abono
      } else {
        strprintdoc =
          "@@" + this.$store.state.curDocType + "@@" + regalo + this.printdoc;
      }

      var ticketPrintReq = {
        printdoc: strprintdoc,
        ticketPrinter: localStorage.getItem("ticketPrinter"),
        ticketControllerURL: window.location.origin + this.ApiBaseUrl + "Tickets/GetTicketInvoice",
      };

      if (
        this.$store.getters.IsPrintable ||
        this.$store.state.orderproperties.CombineShipments != 1
      ) {
        this.OpenSocket(JSON.stringify(ticketPrintReq));
      }
    },
    GenPDFSigned() {
      this.axios
        .post(
          this.ApiBaseUrl + "PosFunctions/GenSalesShipment",
          JSON.stringify(this.printdoc),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          if (response.status === 200) {
            window.open(this.PrintDocsFolder + this.printdoc + ".pdf");
          }
        });
    },
    Finalize() {
      this.$store.dispatch("resetPOS");
      this.$router.push("setup");
    },
    PrintInvoice() {
      this.axios
        .post(
          this.ApiBaseUrl + "PosFunctions/PrintInvoice",
          JSON.stringify(this.$store.state.curOrder),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          window.open(this.PrintDocsFolder + response.data.return_value);
        });
    },
    clearPaym() {
      this.$store.commit("clearPaymMethod");
      this.$store.commit("setPaymMethod", this.$store.state.orderPrePayments);
      this.CurrentAmount = parseFloat(
        this.$store.getters.OrderTotalIncVAT -
          this.$store.getters.OrderTotalPaym
      ).toFixed(2);
      this.ChangeAmount = 0;
      this.$nextTick(() => {
        this.$refs.AmountInput.focus();
      });
    },
    PostPrintPrePayment() {
      if (this.processing === true) {
        return;
      }
      this.processing = true;
      var req = {
        docno: this.$store.state.curOrder,
        //paymmovs : this.$store.state.paymMethods,
        paymmovs: this.$store.getters.NewPaymMovs,
        OrderTotalPaym: this.$store.getters.OrderTotalPaym,
      };
      this.axios
        .post(
          this.ApiBaseUrl + "PosFunctions/PrepaymentPost",
          JSON.stringify(req),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          this.$store.commit("setprintdoc", response.data.return_value);
          this.$refs.ModalRef.show();
          this.processing = false;
        });
    },
    ModalClose() {
      this.$store.dispatch("resetPOS");
      this.$router.push("setup");
    },
    GoToPos() {
      this.$router.push("pos");
    },
  },
};
</script>

<style scoped>
#modal1 {
  text-align: center !important;
}
#modal2 {
  text-align: center !important;
}
</style>